module.exports = __webpack_public_path__ + "assets/851273a616b99b7ece23bb46de6347b2.mp3";